import React from 'react';
import Slider from 'react-slick';
import kilometer from '../../common/assets/images/kilometer.svg';
import setting from '../../common/assets/images/setting.svg';
import locationIcon from '../../common/assets/images/locationWithBase.svg';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useNavigate } from 'react-router-dom';
import { getCarinfoByVin } from '../../utils/api';

const MarketCarInfo = ({ carDetail, setCompare, compare, setLoading, pageType }) => {
    const navigate = useNavigate();
    const { vin, year, make, model, state, city, dealerName, bodyStyle, mileage, price, photoUrls, condition, trim } = carDetail;
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    const handleComparison = (car, key) => {
        if (key === "add") {
            setLoading(true);
            getCarinfoByVin(vin)
                .then((res) => {
                    if (res?.data) {
                        let data = [...compare, { carDetail: car, overView: res?.data }]
                        setCompare(data);
                        localStorage.setItem("compareCars", JSON.stringify(data));
                    }
                })
                .catch((e) => console.error(e)).finally(() => {
                    setLoading(false)
                })
        }
        if (key === "remove") {
            let filteredData = compare.filter((item) => item?.carDetail.vin !== car.vin)
            setCompare(filteredData);
            localStorage.setItem("compareCars", JSON.stringify(filteredData));
        }
    }
    return (
        <>
            <div
                style={{
                    boxShadow: '1px 0px 12px 2px #57575733',
                    border: '0.5px solid #7D7D7D',
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between"
                }}
            >
                <div className='slider-container min-h-[222px] findCardSlider relative'>
                    {photoUrls && <img src={photoUrls[0]} alt='' className='w-full object-fill max-h-[240px]' />}
                    <div className='absolute top-[18px] right-[16px] rounded-[10px] flex items-center cursor-pointer'>
                        <div className='absolute top-[8px] bg-white right-[4px] rounded-[10px] flex items-center cursor-pointer'>
                            {compare.map((item) => item?.carDetail?.vin).includes(vin) ? <>
                                <button className='border-2 px-[10px] py-[2px] rounded-[10px]' onClick={() => handleComparison(carDetail, "remove")}>Remove</button>
                            </> : <>
                                {compare.length < 4 && <button className='border-2 px-[10px] py-[2px] rounded-[10px]' onClick={() => handleComparison(carDetail, "add")}>Select</button>}
                            </>
                            }
                        </div>
                    </div>
                </div>

                <div className='w-full p-3  border-b-[0.5px] border-[#7D7D7D]'>
                    <h2 className='font-semibold'>
                        {year} {make} {model}
                    </h2>
                </div>
                <div className='w-full p-3  border-b-[0.5px] border-[#7D7D7D] '>
                    <h2 className='font-semibold'>Price: {price ? price : "not available"}</h2>
                </div>

                <div className='text-center p-3'>
                    <div className='flex gap-2 pb-2'>
                        <img src={kilometer} alt='' />
                        <p className='text-sm'>{mileage}</p>
                    </div>
                    <div className='flex gap-2 pb-2'>
                        <img src={setting} alt='' />
                        <p className='text-sm'>
                            <div className='flex gap-2 flex-wrap'>
                                {[trim, bodyStyle, condition].map((tag) => {
                                    return (
                                        <p
                                            className='bg-[#E3F5EB] rounded-[100px] py-1 px-2 text-xs text-[#575757]'
                                            key={tag}
                                        >
                                            {tag}
                                        </p>
                                    );
                                })}
                            </div>
                        </p>
                    </div>
                    <div className='flex gap-2 pb-3'>
                        <img src={locationIcon} alt='' />
                        <p className='text-sm text-start'>
                            {dealerName}, {city}, {state}
                        </p>
                    </div>
                </div>

                <div className='flex justify-center p-3'>
                    <button
                        className='darkBlue text-white py-3 mb-2 w-full rounded-xl font-medium'
                        onClick={() => {
                            navigate(`/product_page/${vin}?isSalvage=${pageType === "SalvageCars"}`, { state: { photoUrls } })
                        }
                        }
                    >
                        More Info
                    </button>
                </div>
            </div>
        </>
    )
}

export default MarketCarInfo
